import React from "react";
import { Route, Routes } from "react-router-dom";

import GatewayApp from "./pages/GatewayApp";
import { LicenseProvider } from "./LicenseContext";

export default function App() {
  return (
    <LicenseProvider>
      <Routes>
        <Route path="/" element={<GatewayApp />} />
        <Route path="/:sectionId" element={<GatewayApp />} />
      </Routes>
    </LicenseProvider>
  );
}
